var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgPolicyNote = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.571 5.929a.645.645 0 0 0-.642.642V19.43c0 .353.289.642.642.642h9v-3.214c0-.711.575-1.286 1.286-1.286h3.214v-9a.645.645 0 0 0-.642-.642H6.57zm9 16.071h-9A2.574 2.574 0 0 1 4 19.429V6.57A2.574 2.574 0 0 1 6.571 4H19.43A2.574 2.574 0 0 1 22 6.571v9.221c0 .683-.27 1.338-.751 1.82l-3.636 3.637a2.572 2.572 0 0 1-1.82.751h-.222z",
    fill: "#1A202C",
    fillRule: "nonzero"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPolicyNote, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/policy-note.44ae9d63.svg";
export { ForwardRef as ReactComponent };